import { FormEvent, useId, useRef, useState } from 'react'

import * as S from './Search.styled'

import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField,
  Typography
} from '@themenu/design-system'
import { BlockUI } from 'components'

type SearchProps = {
  initialValue?: string
  label?: string
  placeholder?: string
  isLoading?: boolean
  validate?: boolean
  cta: (val: string) => void
  maxWidth?: number | string
  notClearData?: boolean
  ariaLabel?: string
}

export const Search = ({
  label,
  placeholder,
  isLoading,
  validate = false,
  cta,
  maxWidth = 460,
  initialValue = '',
  notClearData = false,
  ariaLabel = ''
}: SearchProps) => {
  const searchId = useId()

  const formRef = useRef<HTMLFormElement>(null)

  const [term, setTerm] = useState(initialValue)

  const [isOpen, setIsOpen] = useState(false)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (validate && term.length === 0) {
      return setIsOpen(true)
    }

    if (notClearData) {
      cta(term)
      return
    }

    const stringClear = term.replace(/[.-]/g, '')
    cta(stringClear)
  }

  const handleReset = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    cta('')
    setTerm('')
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.stopPropagation()
    }
  }

  const showClearButton = term.length > 0

  return (
    <>
      <S.SearchForm
        ref={formRef}
        onSubmit={handleSubmit}
        onReset={handleReset}
        data-testid="search-form"
        maxWidth={maxWidth}
      >
        <TextField
          id={searchId}
          name="term"
          label={label}
          placeholder={placeholder}
          size={40}
          onChange={(event) => {
            setTerm(event.currentTarget.value)
          }}
          onKeyDown={handleKeyDown}
          value={term}
          aria-label={ariaLabel}
          data-testid="search-input"
          suffix={
            <>
              {showClearButton && (
                <IconButton
                  size={24}
                  mr={4}
                  variant="text"
                  name="cancel"
                  title="Limpar busca"
                  type="reset"
                  data-testid="reset-search-button"
                />
              )}

              <IconButton
                size={32}
                variant="text"
                name="search"
                title="Pesquisar"
                type="submit"
                data-testid="submit-search-button"
              />
            </>
          }
        />
        <BlockUI open={isLoading ?? false} />
      </S.SearchForm>

      <Modal
        onClose={() => setIsOpen(false)}
        title="Atenção"
        isOpen={isOpen}
        data-testid="search-alert-modal"
      >
        <Typography variant="body" weight="medium">
          Digite algo no campo de busca
        </Typography>
        <Box display="flex" justifyContent="flex-end" mt={12}>
          <Button onClick={() => setIsOpen(false)}>Ok</Button>
        </Box>
      </Modal>
    </>
  )
}
